import React, { useState, useEffect } from "react";
import {SinhalaData, EnglishData, TamilData} from  "./../../../../dummyData/handbookDummyData";
import { useSelector } from "react-redux";


const Chapter4 = () => {
    const selectedLanguage = useSelector((state) => state.language.language);
  const [language, setLanguage] = useState(SinhalaData[0]);

    useEffect(() => {
        switch (selectedLanguage.value) {
          case "english":
            setLanguage(EnglishData[0]);
            break;
          case "tamil":
            setLanguage(TamilData[0]);
            break;
          default:
            setLanguage(SinhalaData[0]);
            break;
        }
      }, [selectedLanguage]);
    

    return (
        <>

             {/* Chapter 4 */}
                <section id="section4" className="drivers-handbook-section">
                    <h2 className="drivers-handbook-heading">
                         {language.chapter4Title}
                    </h2>

                    <p className="drivers-handbook-paragraph">
                         {language.chapter4Paragraph1}
                    </p>

                    <p className="drivers-handbook-paragraph">
                        {language.chapter4Paragraph2}
                    </p>

                    <p className="drivers-handbook-paragraph">
                        {language.chapter4Paragraph3}
                    </p>

                    <p className="drivers-handbook-paragraph">
                        {language.chapter4Paragraph4}
                    </p>

                    <p className="drivers-handbook-paragraph">
                        {language.chapter4Paragraph5}
                    </p>

                    <p className="drivers-handbook-paragraph">
                        {language.chapter4Paragraph6}
                    </p>

                    <h3 className="drivers-handbook-subheading">
                        {language.chapter4Subheading1}
                    </h3>
                    <ul className="drivers-handbook-list">
                        <li>{language.chapter4List1}</li>
                        <li>{language.chapter4List2}</li>
                        <li>{language.chapter4List3}</li>
                        <li>
                            {language.chapter4List4}
                        </li>
                        <li>{language.chapter4List5}</li>
                        <li>
                            {language.chapter4List6}
                        </li>
                        <li>{language.chapter4List7}</li>
                        <li>{language.chapter4List8}</li>
                    </ul>

                    <h3 className="drivers-handbook-subheading">
                        {language.chapter4Subheading2}
                    </h3>
                    <ul className="drivers-handbook-list">
                       <li>{language.chapter4List9}</li>
                        <li>{language.chapter4List10}</li>
                        <li>{language.chapter4List11}</li>
                        <li>
                            {language.chapter4List12}
                        </li>
                        <li>{language.chapter4List13}</li>
                        <li>
                            {language.chapter4List14}
                        </li>
                        <li>{language.chapter4List15}</li>
                        <li>{language.chapter4List16}</li>
                    </ul>
                </section>
        </>
    )

}

export default Chapter4;
